import { DataFileInterface } from '@systemeio/file-manager'

export const LOAD_FILES = 'LOAD_FILES'
export const REMOVE_FILE = 'REMOVE_FILE'
export const ADD_FILE = 'ADD_FILE'

export type LoadFilesAction = {
  type: typeof LOAD_FILES
  payload: DataFileInterface[]
}

export type RemoveFileAction = {
  type: typeof REMOVE_FILE
  payload: DataFileInterface
}

export type AddFileAction = {
  type: typeof ADD_FILE
  payload: DataFileInterface
}
